import React, { useEffect, useState, } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import OfflineBoltIcon from '@mui/icons-material/OfflineBolt';
import { pink } from '@mui/material/colors';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { useLocation } from 'react-router';
import {
  getForm,
  getClientInfo,
} from '../actions/Form';
import ErrorPage from "./errorPage";
import { invertColor, contrastText, changeColor } from '../util/General';
import useNetworkStatus from "../hooks/useNetworkStatus";

/**
 * Customize form so each control has more space
 */
const theme = createTheme({
  components: {
    MuiFormControl: {
      styleOverrides: {
        root: {
          margin: '0.8em 0',
        },
      }
    },
    MuiTextField: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiStepper: {
      styleOverrides: {
        root: {
          margin: '2em 0 3em 0',
        },
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          margin: '0.5em 0',
        },
      }
    },
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#9E9E9E',
    },
    secondary: {
      main: '#f50057',
    },
  },
});

const Root = () => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const form_id = searchParams?.get('id')

  const { formData, loading, clientInfo } = useSelector((state) => state.form);
  const dispatch = useDispatch();
  const [country, setCountry] = useState('AU')

  useEffect(() => {
    dispatch(getClientInfo());
    dispatch(getForm(form_id));
  }, []);

  useEffect(() => {
    if (clientInfo?.loc) {
      setCountry(clientInfo?.loc)
    }
  }, [clientInfo])

  const backgroundColour = formData?.theme?.background ? changeColor(formData?.theme?.background, 150) : '#ffffff'
  // const backgroundColour = formData?.theme?.background ? formData?.theme?.background : '#ffffff'

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      { country !== 'AU' ?
        <ErrorPage customStatusText="We noticed you are trying to apply outside Australia. Please return to our website." />
        :
        (!loading && formData) ?
        <div style={{ background: backgroundColour, minHeight: '100vh' }}>
          { formData?.theme?.header_image &&
            <AppBar position="sticky" style={{ background: '#ffffff' }}>
              <Container maxWidth="xl">
                <Toolbar disableGutters>
                  <img
                    alt="..."
                    src={formData?.theme?.header_image}
                    style={{ maxHeight: 80 }}
                  />
                </Toolbar>
              </Container>
            </AppBar>
          }

          <div id="detail">
            <Outlet />
          </div>
        </div>
        :
        <ErrorPage customStatusText="Not Found" type="error" />
      }
    </ThemeProvider>
  );
}

export default Root;
